module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAKCAYAAAC5Sw6hAAABAklEQVQoU5XSTyvmURQH8M+RpsgbmoWazRRRymwsrDQhKX+KhRdgQXlKEplmw2KaGpqilIWy8QbmpYia0pnu0x39PJ4n3OWp87nfc+6NzPyDW8xHxKN3nMzswyE+RmYeYxrf8TUi8i1WZga+YQYnBerHD3zBEeZewypygFn8wlRRZeYH/MQE9rHYC6vIHhZw1kYi/rahBnaKMexiuROrSAtLuMBkQUr/E9TAfmMErYhYbe4rM3ewgsuS/j/yAqrYAAr2GdsRsV7rW1jDVUUempc8S9QYc7BG/4TNWt/ANcYj4r7zZbtCNUHBygjDtekGo92QrqN17GQI57VWktz1+mP/AGH2X30BBVV6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/menudown.png
// module id = CYxk
// module chunks = 1